<template>
  <div
    class="c-filter o-grid o-grid--direction-row o-grid--align-items-center o-grid--justify-content-start"
  >
    <div class="o-grid__group">
      <div class="o-grid__item" v-for="(filter, name) in filters" :key="name">
        <div class="c-filter__item c-filter__item--filter">
          <div
            class="o-grid o-grid--gutter-tiny o-grid--direction-row o-grid--align-items-center o-grid--justify-content-start"
          >
            <div class="o-grid__group">
              <div class="o-grid__item">
                <label class="c-filter__item-label">{{
                  filtersTranslations[name].name
                }}</label>
              </div>
              <div class="o-grid__item" :ref="`filter-${name}`">
                <v-select
                  label="name"
                  :placeholder="filtersTranslations.all"
                  :searchable="false"
                  v-model="parameters[name]"
                  :options="filter"
                  :reduce="
                    option => (isNaN(option.id) ? option.id : Number(option.id))
                  "
                  @input="filterChange($event, filter, name)"
                  :inputId="`filter-${name}`"
                >
                  <template #selected-option="value">
                    {{ setSelectedOption(value, name) }}
                  </template>
                </v-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="o-grid__item"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "c-filter",
  computed: {
    ...mapState("tips", ["filters", "parameters"]),
    ...mapState("authentication", ["userInfo"]),
    ...mapState("translations", {
      filtersTranslations: "filters"
    }),
    token: () => {
      var user =
        JSON.parse(localStorage.getItem("user")) ||
        JSON.parse(sessionStorage.getItem("user"));

      if (user && (user.access_token || user.accessToken)) {
        return user.access_token;
      } else {
        return null;
      }
    },
    exportLink() {
      return `${this.$api}/api/v4/aedsexport.xlsx?token=${this.token}`;
    }
  },
  methods: {
    filterChange() {
      this.parameters.pageNo = 1;
      const payload = {
        api: this.$api,
        parameters: this.parameters
      };
      const { dispatch } = this.$store;
      dispatch("tips/getAll", payload);
    },
    translateOptions() {
      Object.keys(this.filters).forEach(filterKey => {
        this.filters[filterKey].forEach(option => {
          let translation = "";
          if (option.id === this.userInfo.Id) {
            translation = this.filtersTranslations[filterKey].options.find(
              filterOption => filterOption.id === 0
            );
          } else {
            translation = this.filtersTranslations[filterKey].options.find(
              filterOption => filterOption.id === option.id
            );
          }
          return (option.name = translation ? translation.name : option.name);
        });
      });
    },
    setSelectedOption(value, name) {
      let label = value.name;
      if (!value.id) {
        this.filters[name].forEach(option => {
          if (option.id == value.name) {
            label = option.name;
          }
        });
      }
      return label;
    }
  },
  created() {
    this.translateOptions();
  }
};
</script>

<style lang="scss">
.c-filter {
  $dropdown: ".vs";
  padding: toRem(25px 0);
  .o-grid__item {
    flex: 0 0 auto;
    &:last-child {
      margin-left: auto;
    }

    &:first-child {
      .c-filter__item--filter {
        &:before {
          content: "";
          display: block;
          height: 18px;
          background: $s-cp-neutral-600;
          width: 1px;
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
        }
      }
    }
  }
  &__item {
    display: block;

    &--heading {
      font-weight: 700;
    }

    &--filter {
      position: relative;
      &:after {
        content: "";
        display: block;
        height: 18px;
        background: $s-cp-neutral-600;
        width: 1px;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
      }
      padding: 0 5px 0 15px;
    }
  }

  &__item-label {
    font-weight: 700;
    color: $s-cp-neutral-300;
    @include setStyles("14", $s-typography-sizes);
  }

  .v-select {
    width: 100%;

    &#{$dropdown}--single {
      &#{$dropdown}--open {
        #{$dropdown}__selected {
          position: relative;
        }
      }
    }

    &.vs--open {
      .vs__selected-options {
        height: 100%;
        background-color: $s-cp-neutral-700;
        border-color: $s-cp-neutral-600;
      }
      .vs__open-indicator,
      .vs__clear {
        stroke: $s-cp-neutral-700;
      }
    }
    .vs {
      &__search,
      &__search:focus {
        height: toRem(30px);
        vertical-align: middle;
        border: 1px solid transparent;
        flex: 0 0 60px;
        width: 60px;
        @include setStyles("14", $s-typography-sizes);
        padding: 0 10px;
        margin: 0;

        &::placeholder {
          color: $s-cp-sup-blue;
        }
      }
      &__selected-options {
        padding: 0;
        border: 1px solid transparent;
        border-radius: 2px;
      }
      &__selected {
        margin: 0;
        height: toRem(30px);
        padding: 5px 45px 4px 10px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        display: block;
        width: auto;
        @include setStyles("14", $s-typography-sizes);
        color: $s-cp-sup-blue;
        pointer-events: none;

        + #{$dropdown}__search {
          opacity: 0;
          position: absolute;
          width: 100%;
        }
      }
      &__actions {
        padding: 0;
        width: auto;
        justify-content: flex-end;
        pointer-events: none;

        button {
          pointer-events: auto;
        }
      }

      &__open-indicator,
      &__clear {
        fill: $s-cp-sup-blue;
        stroke: $s-cp-neutral-900;
      }

      &__clear {
        fill: $s-cp-sup-red;
      }

      &__dropdown-toggle {
        padding: 0;
        border: none;
      }
      &__dropdown-menu {
        margin: 0;
        box-shadow: 0 1px 4px 0 rgba(30, 30, 30, 0.15);
        border-radius: 0 0 3px 3px;
        border: 1px solid $s-cp-neutral-600;
        padding: 0 0 5px;
        width: auto;
        min-width: unset;
      }
      &__dropdown-option {
        padding: 3px 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        @include setStyles("15", $s-typography-sizes);

        &--highlight {
          background-color: $s-cp-sup-light;
          color: $s-cp-main;
        }
      }
    }
  }

  .c-export {
    color: $s-cp-sup-blue;
    @include setStyles("14", $s-typography-sizes);
    line-height: toRem(16px);
    text-decoration: none;
    display: block;

    &__logo {
      width: toRem(20px);
      height: toRem(20px);
      margin-right: toRem(10px);
      display: inline-block;
      vertical-align: middle;
    }
  }
}
</style>
